module.exports = __webpack_public_path__ + "static/media/Bill.992c7b52.svg";